export default "__VITE_ASSET__BW$vaRK___"